import React from 'react'
import styled, { css } from 'styled-components'
import { Link } from 'gatsby'
import { forLargeScreenUp } from '../utils/style'
import logo from '../images/logo.svg'
import { SearchBox, SearchIcon } from './SearchBox'
import { useSearch } from '../hooks/useSearch'
const isBrowser = typeof window !== 'undefined'
const isSearchPage = () => {
  if (!isBrowser) return false
  return window.location.href.includes('/search')
}

const Wrapper = styled.header`
  position: fixed;
  z-index: 999;
  top: 0;
  left: 0;
  right: 0;
  height: var(--headerHeight);
  box-shadow:
    0 0.5rem 1rem rgb(0 0 0 / 5%),
    inset 0 -1px 0 rgb(0 0 0 / 10%);
  background: #fff;
`

const HeaderContainer = styled.div`
  display: grid;
  grid-template-columns: 256px 320px auto;
  height: 100%;
  align-items: center;
  max-width: var(--layout-width);
  margin: auto;

  @media screen and (max-width: 1060px) {
    grid-template-columns: 256px auto !important;
  }
`

const HeaderContainerCommon = styled(HeaderContainer)`
  grid-template-columns: ${(props) =>
    props.isSearchPage ? '256px auto' : '256px 320px auto'};
`

const Logo = styled(Link)`
  display: block;
  height: 40px;
  img {
    margin: 0 0 0 var(--spacing-3);
    height: 100%;
  }
`

const NavItem = styled.span`
  display: none;
  text-align: center;
  white-space: nowrap;
  a {
    color: #0009;
  }
  a:hover {
    color: #000;
  }
  @media screen and (min-width: 670px) {
    display: inline-block;
    width: 110px;
  }
  ${forLargeScreenUp(css`
    width: 160px;
  `)}
`

const NavItemSearch = styled(NavItem)`
  display: none;
  width: 80px;
  @media screen and (max-width: 1060px) {
    display: inline-flex;
    justify-content: center;
  }
`
const NavWrapper = styled.div`
  display: flex;
  flex-flow: row;
  justify-content: flex-end;
  flex-wrap: nowrap;
`

export const SearchForm = styled.form`
  margin: 0;
  @media screen and (max-width: 1060px) {
    display: none;
  }
`

export const Header = ({ title }) => {
  const search = useSearch()
  return (
    <Wrapper>
      <HeaderContainerCommon isSearchPage={isSearchPage()}>
        <Logo to="/">
          <img src={logo} alt={title} />
        </Logo>
        {!isSearchPage() && (
          <SearchForm onSubmit={search.handleSubmit}>
            <SearchBox
              searchTerm={search.searchTerm}
              onChange={search.handleChange}
            />
          </SearchForm>
        )}
        <Nav />
      </HeaderContainerCommon>
    </Wrapper>
  )
}

const Nav = () => {
  return (
    <NavWrapper>
      <nav>
        <NavItem>
          <Link to="/">Home</Link>
        </NavItem>
        <NavItem>
          <a href="https://www.cybozu.vn/about-us/">About Us</a>
        </NavItem>
        <NavItem>
          <a href="https://www.cybozu.vn/career-opportunities/">Careers</a>
        </NavItem>
        {!isSearchPage() && (
          <NavItemSearch>
            <Link to="/search" title="Search">
              <SearchIcon />
            </Link>
          </NavItemSearch>
        )}
      </nav>
    </NavWrapper>
  )
}
